<template>
  <v-card color_="blue-grey darken-2" class_="white--text" class="elevation-2">
    <v-card-title primary-title class_="blue-grey darken-2">
      <div>
        <div class="subtitle-1 font-weight-medium mb-2">
          Produtos Vendidos por Fornecedor
        </div>
        <div class="body-2">
          Relação dos produtos vendidos por fornecedor no período.
        </div>
      </div>
    </v-card-title>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        depressed 
        color="primary" 
        @click="$refs.dialogo.abrir()"
      >Opções</v-btn>
    </v-card-actions>

    <v-divider v-show="aberto"></v-divider>

    <z-dialogo
      ref="dialogo"
      titulo="PRODUTOS VENDIDOS POR FORNECEDOR"
      largura="500px"
      persistent
    >
      <template v-slot:texto>
        <v-row dense>
          <v-col cols="12" sm="6">
            <z-date-picker-menu
              filled
              dense
              label="Data Incial"
              v-model="filtro.data_inicial"
            ></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <z-date-picker-menu
              filled
              dense
              label="Data Final"
              v-model="filtro.data_final"
            ></z-date-picker-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete
              filled
              dense
              v-model="filtro.fornecedor_id"
              :items="$store.state.listas.fornecedores"
              clearable
              label="Fornecedor"
              placeholder=" "
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-select
              filled
              dense
              :items="ordenacao"
              label="Ordenar por"
              placeholder=" "
              v-model="filtro.ordem"
            ></v-select>
          </v-col>
        </v-row>
      </template>

      <template v-slot:actions_right>
        <v-spacer></v-spacer>
        <v-btn text @click="$refs.dialogo.fechar()">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimir">Imprimir</v-btn>
      </template>
    </z-dialogo>
  </v-card>
</template>

<script>
import qs from "qs";
import config from "../../app/config";
export default {
  name: "produtos-vendidos-por-fornecedor",
  data() {
    return {
      aberto: false,
      filtro: {
        data_inicial: this.$moment().format("YYYY-MM-DD"),
        data_final: this.$moment().format("YYYY-MM-DD"),
        ordem: "quantidade_total",
        fornecedor_id: "",
      },
      ordenacao: [
        { text: "Quantidade", value: "quantidade_total" },
        { text: "Sub Total", value: "subtotal" },
        { text: "Descrição", value: "descricao" },
        { text: "Referência", value: "referencia" },
      ],
    };
  },

  inject: ["$imprimir"],

  methods: {
    imprimir() {
      this.$imprimir("relatorios/produtosvendidosporfornecedor?" + new URLSearchParams(this.filtro).toString(), "produtos_vendidos_por_fornecedor.pdf");
    },
  },
};
</script>

<style scoped>
</style>